import React, { useContext, createContext } from "react";
import axiosFactory, { METHOD_POST, METHOD_GET } from "../helpers/AxiosFactory";
import {
  GET_MY_EVENTS,
  CREATE_EVENT,
  UPDATE_EVENT,
  DELETE_EVENT,
} from "../helpers/UrlConstants";

const EventContext = createContext();
export function useEventContext() {
  return useContext(EventContext);
}
export default function EventProvider({ children }) {
  async function getMyEvents(token) {
    return await axiosFactory({
      url: GET_MY_EVENTS,
      method: METHOD_GET,
    });
  }
  async function createEvent(data) {
    return await axiosFactory({
      url: CREATE_EVENT,
      method: METHOD_POST,
      data: data,
    });
  }
  async function updateEvent(data) {
    return await axiosFactory({
      url: UPDATE_EVENT,
      method: METHOD_POST,
      data: data,
    });
  }
  async function deleteEvent(data) {
    return await axiosFactory({
      url: DELETE_EVENT,
      method: METHOD_POST,
      data: data,
    });
  }
  const value = {
    getMyEvents,
    createEvent,
    updateEvent,
    deleteEvent,
  };
  return (
    <EventContext.Provider value={value}>{children}</EventContext.Provider>
  );
}
